import { cn } from "cn";
import type { ComponentProps, FC } from "react";
import React from "react";

import { DropdownMenuItem as BaseDropdownMenuItem } from "../shadcn/ui/dropdown-menu.tsx";

export * from "../shadcn/ui/dropdown-menu.tsx";

export const DropdownMenuItem: FC<
  ComponentProps<typeof BaseDropdownMenuItem>
> = ({ className, onClick, ...props }) => (
  <BaseDropdownMenuItem
    className={cn(onClick && "cursor-pointer", className)}
    onClick={onClick}
    {...props}
  />
);
